<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Badge from '@/components/molecules/Badge'
import CartBlock from '@/components/organism/CartBlock.vue'
const restaurant = Vue.prototype.$restaurant

export default {
    name: 'ToggleCart',
    components: { Badge, CartBlock },
    data() {
        return {
            showCart: false,
            viewMenu: false,
        }
    },
    computed: {
        restaurant: () => restaurant,
        ...mapGetters({
            activeCurrency: 'active/currency',
            activeRestaurant: 'active/restaurant',
            orderRestaurant: 'order/restaurant',
            smDevice: 'smDevice',
            cartOpen: 'site/cartOpen',
            listView: 'site/listView',
        }),
        cart() {
            return this.$cart
        },
        hasContent() {
            return Boolean(
                (this.orderRestaurant?.id === this.restaurant?.id || !this.activeRestaurant?.id) &&
                    this.cart?.items?.length
            )
        },
        price() {
            return this.cart.calculated && this.hasContent ? this.cart.calculation.price_sum : null
        },
        subTotal() {
            return this.cart.calculated && this.hasContent && this.cart.calculation.price_sum_items
                ? this.cart.calculation.price_sum_items
                : null
        },
        minimumOrder() {
            return this.restaurant.location_info && this.restaurant.location_info.minimum_order
                ? this.restaurant.location_info.minimum_order
                : null
        },
        showHelper() {
            return this.minimumOrder && this.subTotal < this.minimumOrder
        },
        showToggleCart() {
            return (
                this.$route?.meta?.smallDevice?.showCart &&
                !this.cart.isEmpty &&
                (this.listView || this.orderRestaurant.id === this.activeRestaurant.id)
            )
        },
        currency() {
            return this.activeCurrency.locale ? this.activeCurrency : this.orderRestaurant.country
        },
    },
    watch: {
        'cart.isEmpty': {
            immediate: true,
            handler(isEmpty, isEmptyBefore) {
                if ((isEmptyBefore === undefined || isEmptyBefore) && !isEmpty) {
                    this.showCart = true
                }
            },
        },
        cartOpen: {
            handler(cartOpen, cartOpenBefore) {
                if (cartOpenBefore && !cartOpen && this.showCart && this.cart.isEmpty) {
                    setTimeout(() => {
                        this.showCart = false
                    }, 25)
                }
            },
        },
    },
    methods: {
        viewCart() {
            if (this.smDevice) {
                this.$store.dispatch('site/setCart', true)
                this.$store.dispatch('blockScroll', true)
            }
        },
    },
}
</script>

<template lang="pug">
.toggle-cart-wrapper(v-if="smDevice")
    transition(name="toggle-cart")
        .card.toggle-cart.border-radius-0.shadow-2(v-if="showToggleCart")
            .card-body.py-4.px-5.text-center(:class="")
                template(v-if="minimumOrder && subTotal < minimumOrder  && activeRestaurant && activeRestaurant.id && currency" )
                    badge.mb-4(v-if="minimumOrder > subTotal && subTotal > 0" type="warning" pill)
                        | {{ minimumOrder - subTotal | toCurrency(currency.locale, currency.currency_code)}} {{$t('cart.till_minimum_order') }}
                    p.body-m.text-73.mb-4(v-else)
                        | {{ minimumOrder | toCurrency(currency.locale, currency.currency_code)}} {{$t('cart.minimum_order') }}
                button.btn.btn-primary.btn-block.btn-lg.btn-currency(@click="viewCart" :class="{'mt-4': !minimumOrder}")
                    span {{$t('cart.view_basket')}}
                    transition(name="fade")
                        span.ml-2(v-if="price > 0 && currency && currency.locale") ({{price | toCurrency(currency.locale, currency.currency_code)}})  
    cart-block(:restaurant="restaurant")
</template>
